<template>
  <div class="columns mgt-20px is-multiline">
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{$t('societes.tab.infosGeneral')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-4">
              <b-field :label="$t('societes.signatureToken')">
                <b-input expanded v-model="societe.signatureElectroniqueToken"></b-input>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('societes.signatureReference')">
                <b-input expanded v-model="societe.signatureElectroniqueReferenceExterne"></b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p> {{ $t('signatureElectronique.initialisation.title')}} </p>
        </header>
        <div class="card-content">
          <button class="button is-primary" @click="intialiseCallBack()">
            {{ $t('signatureElectronique.initialisation.callBack') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { LISTE_DESTINATAIRE_COMPTABLE } from '@/configuration/societe/societe';
import { initialiseCallBack } from '@/api/signatureElectronique/initialise';
import messageSuccess from '@/services/general/messageSucces';
import validation from '@/services/signatureElectronique/validation/validation';
import messageErreur from '@/services/general/messageErreur';

export default {
  props: {
    societe: Object,
  },
  data() {
    return {
      showEdit: false,
      constantes: {
        LISTE_DESTINATAIRE_COMPTABLE,
      },
    };
  },
  methods: {
    async intialiseCallBack() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await initialiseCallBack(this.societe.id);
        messageSuccess(this.$i18n.t('signatureElectronique.initialisation.successCallBack'));
        loadingComponent.close();
      } catch (e) {
        if (e.response) {
          this.messages = [];
          validation(e.response, this.messages);
          this.error = true;
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw e;
      }
    },
  },
};
</script>
